/** Compatibility export; the business domain owns this implementation. */
export { EnumPodCategory, EnumPodMarketplace, EnumPodPlatform, POD_PLATFORMS_MAPPING } from '@domains/research/shared';
